<template>
  <div>
    <DenyR :id="id" :status="status" />
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div
                class="col-md-1 remove-right-padding col-center-flex"
                style="cursor: pointer"
                @click="$router.go(-1)"
              >
                <img src="@/assets/img/arrowLeft.png" width="60px" />
              </div>
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/money-transfer.svg" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h6 class="primary-color font-600">
                  {{ $route.query.branches }} {{ $t("text.omit.approvePrice") }}
                </h6>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.priceManager.desc2") }}
                </p>
              </div>

              <div class="col-md-5 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.products.total") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img
                          src="@/assets/img/money-transfer.svg"
                          width="40px"
                        />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ pcNo }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="invoice-banner mt-3">
          <div class="aggregate_change_input_wrapper w-25">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :color="$store.getters.getDatePickerColor"
              format="YYYY-MM-DDTHH:mm:ss"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.selectDate')"
            />
          </div>
        </div> -->
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="70" field="index" headerText="#"></e-column>
                <e-column
                  field="dateCreated"
                  width="200"
                  :headerText="$t('text.cWaybill.date')"
                ></e-column>
                <e-column
                  width="220"
                  field="userFullName"
                  :headerText="$t('text.form.fullName')"
                ></e-column>
                <e-column
                  width="270"
                  field="userEmail"
                  :headerText="$t('text.form.email')"
                ></e-column>
                <e-column
                  width="120"
                  field="position"
                  :headerText="$t('text.priceManager.level')"
                ></e-column>
                <e-column
                  width="200"
                  field="positionName"
                  :headerText="$t('text.priceManager.position')"
                ></e-column>
                <!-- <e-column
                  width="150"
                  field="typeName"
                  :headerText="$t('text.cAggregated.type')"
                ></e-column> -->
                <e-column
                  width="150"
                  field="status"
                  :headerText="$t('text.actionButtons.status')"
                ></e-column>
                <e-column
                  width="200"
                  :template="PriceChangeTemp"
                  headerText=""
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import PriceChangeTemp from "@/components/Templates/approvePriceChangeTemp";
import DenyR from "@/components/modals/PriceChange/DenyReason";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Price change approval :: Epump Portal",
  name: "PCA",
  components: {
    MasterLayout,
    TableLoader,
    PriceChangeTemp,
    DenyR,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: {
        start: this.$moment().subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss"),
        end: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      },
      company: null,
      branch: null,
      group: null,
      backgroundUrl,
      cardBackgroundUrl,
      companyId: null,
      showLoader: true,
      pcNo: 0,
      priceChangeList: [],
      waybillId: "",
      // users: [],
      entityType: this.$route.query.entityType,
      status: "",
      id: "",
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      PriceChangeTemp: function () {
        return {
          template: PriceChangeTemp,
        };
      },
    };
  },
  watch: {
    // company(company) {
    //   if (company !== null) {
    //     this.company = company;
    //   }
    // },
    // dateRange: function (newRange, oldRange) {
    //   if (newRange.start !== null && newRange.end !== null) {
    //     this.updateRouteQuery();
    //     this.getPriceChange();
    //   }
    // },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.companyId = company.id;
      // this.getPriceChange();
    });

    if (this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId;
    }

    if (this.$route.query.Id) {
      this.getPriceChange();
    }
    this.$eventHub.$on("getPriceChange", () => {
      this.getPriceChange();
    });
    this.$eventHub.$on("_markDeclined", (id, status) => {
      this.markPriceDenied(id, status);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("getPriceChange");
    this.$eventHub.$off("_markDeclined");
  },
  mounted() {
    // console.log(this.entityType);

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    // this.updateRouteQuery();
  },
  methods: {
    // updateRouteQuery() {
    //   let queries = JSON.parse(JSON.stringify(this.$route.query));
    //   queries.dateRange = JSON.stringify(this.dateRange);
    //   this.$router.replace({ query: queries });
    // },
    markPriceDenied(id, status) {
      this.id = id;
      this.status = status;
      this.$modal.show("denyReason");

      // let remove;
      // if (status == "Approve") {
      //   remove = confirm(this.$t("text.priceManager.approveWarn"));
      // } else {
      //   remove = confirm(this.$t("text.priceManager.declineWarn"));
      // }
      // if (!remove) {
      //   return;
      // }
      // const data = {
      //   status: status,
      // };
      // this.axios
      //   .post(
      //     `${configObject.apiBaseUrl}/Approval/UpdateStatus/${id}`,
      //     data,
      //     configObject.authConfig()
      //   )
      //   .then((res) => {
      //     this.$toast.open({
      //       message:
      //         status == "Approve"
      //           ? this.$t("text.priceManager.approveSuccess")
      //           : this.$t("text.priceManager.declineSuccess"),
      //       type: "success",
      //       duration: 4000,
      //     });
      //     this.getPriceChange();
      //   })
      //   .catch((error) => {
      //     this.$toast.open({
      //       message: error.response.data.message,
      //       type: "error",
      //       duration: 4000,
      //     });
      //   });
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Price_Change_Approval_List.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].width = "200";
          this.$refs.dataGrid.getColumns()[5].width = "200";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          // this.$refs.dataGrid.getColumns()[4].visible = false;
          // this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},

    convertThousand(request) {
      if (request === null || request === "null") {
        return "0.00";
      }
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getPriceChange() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Approval/ActionType/${this.$route.query.Id}`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.showLoader = false;
          this.priceChangeList = response.data;
          this.pcNo = response.data.length;
          let index = 0;
          // response.data.sort((a, b) => {
          //   return a.dateCreated > b.dateCreated ? 1 : -1;
          // });
          response.data.forEach((x) => {
            x.index = ++index;
            x.dateCreated = this.$moment(x.dateCreated).format(
              "MMM Do YYYY, h:mma"
            );
            // x.price = this.convertThousand(x.price);
            // x.oldPrice = this.convertThousand(x.oldPrice);
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
